<template>
  <div>
    <button @click="login('steam')" class="signInButton steamButton">
      <icon-steam />
      <div class="buttonText">Sign in with Steam</div>
    </button>
    <button @click="login('facebook')" class="signInButton fbButton">
     <icon-facebook-white />
      <div class="buttonText">Sign in with Facebook</div>
    </button>
    <!--
    <button @click="login('twitter')" class="signInButton twitterButton">
    <icon-twitter-white />
      <div class="buttonText">Sign in with Twitter</div>
    </button> -->
    <button @click="login('google')" class="signInButton googleButton">
      <icon-google />
      <div class="buttonText">Sign in with Google</div>
    </button>
  </div>
</template>

<script>
import { mapActions } from "vuex";

import SocialIcons from "@/components/partials/icons";

export default {
  name: "form-third-party-login",
  components: { ...SocialIcons },
  props: {
    active: {
      type: [String, Boolean],
      defautl: ""
    }
  },
  methods: {
    ...mapActions("user", {
      loginThirdParty: "loginThirdParty"
    }),
    login: function(provider) {
      this.loginThirdParty(provider);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "./../../../assets/scss/vars";

.signInButton {
  display: flex;
  justify-content: left;
  align-items: center;
  width: 100%;
  padding: 1rem 1.5rem;
  border: 2px solid $gray7;
  cursor: pointer;
  margin-bottom: 1rem;
  font-weight: bold;
  color: white;
}

.steamButton {
  background-color: $gray11;
  border-color: $gray11;
}

.fbButton {
  background-color: #4267B2;
  border-color: #4267B2;
}

.twitterButton {
  background-color: #1DA1F2;
  border-color: #1DA1F2;
}

.googleButton {
  border-color: $gray11;
  color: $gray11;
}

.buttonText {
  margin-left: 1rem;
}
</style>
